import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setIsExpertDashboardOpened, setShowTools, selectInboxTabWithLoad } from 'actions';
import environment from 'environment';
import { extractDisplayingHistoricalConversationFromState } from 'extractFromState';
import { Wrapper, Iframe } from './ExpertDashboard.styles';
import { useLocation } from 'react-router-dom';
import { shareSessionTokenWithExpertDashboard } from 'util/devUtils';

const ExpertDashboard = () => {
  const [windowHeight, setWindowHeight] = useState(0);
  const dispatch = useDispatch();

  const location = useLocation();
  const shareId = new URLSearchParams(location.search).get('shareId');

  const historicalConvoActiveInPlatform = useSelector((state) =>
    extractDisplayingHistoricalConversationFromState(state)
  );

  useEffect(() => {
    // set flag to hide action buttons and disable tab picker
    dispatch(setIsExpertDashboardOpened(true));
    dispatch(setShowTools(false));
    updateWindowDimensions();
    window.addEventListener('resize', updateWindowDimensions);

    // shares session token and user data with expert-dashboard when apps run on localhost
    shareSessionTokenWithExpertDashboard();

    return () => {
      window.removeEventListener('resize', updateWindowDimensions);
      dispatch(setIsExpertDashboardOpened(false));

      // This check is necessary to prevent bugs resulting from switching back to the platform when a historical conversation was active before expert dash was opened. If true, it will reset back to the nominated queue which clears historical ticket
      if (historicalConvoActiveInPlatform) {
        dispatch(selectInboxTabWithLoad('nominated'));
      }
    };
  }, [historicalConvoActiveInPlatform, dispatch]);

  const updateWindowDimensions = () => {
    setWindowHeight(window.innerHeight);
  };

  const getDashboardHeight = () => windowHeight - 45;

  const baseUrl = environment.expertDashboardUrl;
  const iframeSrc = shareId ? `${baseUrl}?shareId=${encodeURIComponent(shareId)}` : baseUrl;

  return (
    <Wrapper>
      <Iframe height={getDashboardHeight()} src={iframeSrc} />
    </Wrapper>
  );
};

export default ExpertDashboard;
